import helpers from "@/lib/helpers";
import store from "@/store";
import Printer from "@/lib/printer";

const failed = {}
const LOCKOUT_TIME = 60 * 60 * 5

export class PrintError extends Error {
    constructor(local_error, remote_error) {
        super('Print Failed')
        this.name = 'PrintError'
        this.local_error = local_error;
        this.remote_error = remote_error;
    }
}

export function useDocs() {
    const printLocalUrl = async (print_config, url, copies, options) => {
        let label

        try {
            label = await helpers.asyncAction(url.href, 'GET', {
                quiet: true,
                params: {
                    ...options,
                    copies,
                    printer: print_config.name
                }
            })
        } catch (error) {
            console.log('Label template error', error)
            return false
        }

        const local_config = label.local || print_config.local

        if (!local_config)
            return helpers.alert('No local config for printer')

        return Printer.print(local_config, label.document, label.copies)
    }

    const printDoc = async (printer, type, url, copies, quiet, options, localonly) => {
        if (!printer) {
            helpers.alert("No printer specified")
            return
        }

        copies = copies || 1

        const printers = store.state.settings.defaults.printers[type]
        if (!printers || printers.length === 0) {
            helpers.alert('No printers available for ' + type)
            return
        }

        const printer_config = printers.find(p => p.name === printer)

        if (!printer_config) {
            helpers.alert(`Invalid printer '${printer}' for ${type}`)
            return false
        }

        const can_local = printer_config.local && (await Printer.can(printer_config.local))

        let attempted = false
        let remote_error = null
        let local_error = null

        const locked_out = failed[printer] && ((Math.floor(Date.now() / 1000) - failed[printer]) < LOCKOUT_TIME);
        locked_out && console.log('Remote printer locked out due to previous failure')

        if (!printer_config.local_only && !localonly && !locked_out) {
            if (failed[printer])
                delete (failed[printer])

            attempted = true
            try {
                await helpers.asyncAction(url.href, 'PUT', {
                    quiet: true,
                    data: {
                        ...options,
                        printer,
                        copies
                    },
                });
                if (!quiet)
                    helpers.toast('Doc printed')
                return true
            } catch (e) {
                console.log('print exception', e)
                remote_error = e.message || 'Remote print failed'
            }
        }

        if (can_local) {

            try {
                const transport = await printLocalUrl(printer_config, url, copies, options)
                if (!transport)
                    throw new Error('Error getting label template')

                if (attempted)
                    failed[printer] = Math.floor(Date.now() / 1000)

                attempted = true

                remote_error = null
                if (!quiet)
                    helpers.toast('Doc printed via ' + transport)
            } catch (e) {
                if (failed[printer])
                    delete (failed[printer])

                if (e.name !== 'SecurityError')
                    local_error = e.toString()
                attempted = true
            }
        }

        if (quiet) {
            if (!attempted)
                throw new Error('Printer not available for this platform')
            else if (local_error || remote_error)
                throw new PrintError(local_error, remote_error)
        } else {
            if (!attempted)
                helpers.toast("Printer not available for this platform", 'danger')
            else {
                if (local_error)
                    helpers.toast(local_error, 'danger', 'Local Print Error')
                if (remote_error)
                    helpers.toast(remote_error, 'danger', 'Remote Print Error')
            }
        }
    }

    return {printDoc}
}
